<div class="no-access">
  <div class="flex flex-col items-center gap-8">
    <div class="icon">
      <span class="material-symbols-rounded scale-150">
        account_circle_off
      </span>
    </div>
    <p class="text-[#707070] text-lg">{{ message }}</p>
    <button (click)="backToLogin()" class="back-to-login-button">
      <span class="material-symbols-rounded chevron">chevron_left</span
      ><span>{{ "no-access.button" | translate }}</span>
    </button>
  </div>
</div>
